import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, type IssueRow } from "../api";
import { useProjects } from "../project-context";
import { relTime } from "../time";

const FILTERS = [
  { key: "unresolved", label: "Uløst" },
  { key: "", label: "Alle" },
  { key: "resolved", label: "Løst" },
  { key: "ignored", label: "Ignorert" },
];

export function Issues() {
  const { selected, loading: projLoading } = useProjects();
  const nav = useNavigate();
  const [filter, setFilter] = useState("unresolved");
  const [rows, setRows] = useState<IssueRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selected) return;
    setLoading(true);
    api
      .issues(selected.id, filter || undefined)
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [selected, filter]);

  if (projLoading) return <div className="spin" />;
  if (!selected) {
    return (
      <div className="card reveal" style={{ marginTop: 40 }}>
        <h3 className="card-title">Ingen prosjekter</h3>
        <p style={{ color: "var(--muted)" }}>Opprett et prosjekt for å se feil.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="page-head">
        <div>
          <span className="eyebrow">{selected.name}</span>
          <h1 className="page-title">Feil</h1>
        </div>
        <div className="tabs">
          {FILTERS.map((f) => (
            <button key={f.key} className={f.key === filter ? "on" : ""} onClick={() => setFilter(f.key)}>
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="spin" />
      ) : rows.length === 0 ? (
        <div className="card reveal">
          <div className="empty">ingen feil her — bra jobba 🎉</div>
        </div>
      ) : (
        rows.map((r) => (
          <div
            key={r.id}
            className={`issue-row reveal ${r.status === "resolved" ? "resolved" : ""}`}
            onClick={() => nav(`/issues/${r.id}`)}
          >
            <div className="issue-main">
              <div className="issue-title">
                {r.type && <span className="type">{r.type} </span>}
                {r.title.replace(new RegExp(`^${r.type}:\\s*`), "")}
              </div>
              <div className="issue-sub">
                {r.culprit ?? "ukjent opphav"} · sist {relTime(r.last_seen)}
              </div>
            </div>
            <span className={`pill ${r.status}`}>{r.status}</span>
            <div className="issue-count">
              {new Intl.NumberFormat("nb-NO").format(r.count)}
              <small>HENDELSER</small>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
